import {
  TrendingUp,
  TrendingDown,
  Layers,
  Sparkles,
  FlaskConical,
} from "lucide-react";

export const NOTIFICATION_TYPE_ICONS: Record<string, React.ElementType> = {
  signal: Sparkles,
  rank_up: TrendingUp,
  rank_down: TrendingDown,
  landscape_complete: Layers,
  ab_test_results: FlaskConical,
};

export const NOTIFICATION_TYPE_COLORS: Record<string, string> = {
  signal: "text-primary",
  rank_up: "text-trend-positive",
  rank_down: "text-trend-negative",
  landscape_complete: "text-primary",
  ab_test_results: "text-primary",
};

export const TYPE_LABELS: Record<string, string> = {
  signal: "Signal",
  rank_up: "Rank Up",
  rank_down: "Rank Down",
  landscape_complete: "Landscape",
  ab_test_results: "A/B Test",
};

export function formatRelativeTime(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime();
  const minutes = Math.floor(diff / 60000);
  if (minutes < 60) return `${Math.max(1, minutes)}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}
